import _ from 'underscore'
import ShowBalanceHistoryCellRenderer from './ShowBalanceHistoryCellRenderer'
import messageResource from '../../../../messageResource'

function ShowSickDaysHistoryCellRenderer() {
    this.constructor = ShowSickDaysHistoryCellRenderer;
}

ShowSickDaysHistoryCellRenderer.prototype = _.create(ShowBalanceHistoryCellRenderer.prototype, {

    getCellGeneralClassName: function() {
        return "showSickDaysHistoryCell";
    },

    getFlagValue: function(value) {
        return value.sick;
    },

    getCellTooltipText: function() {
        return messageResource.getMessage("common.sick_history.show_sick_history.tooltip.text");
    }
});

export default ShowSickDaysHistoryCellRenderer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/ShowSickDaysHistoryCellRenderer.js